module.exports = __webpack_public_path__ + "static/img/pro_tab2.40b1d70.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/advertisement/introduceFour/pro_tab2.jpg
// module id = N4k8
// module chunks = 171